import { LOCATION_CHANGE } from "connected-react-router";
import { Middleware } from "redux";

import { RootState } from "../rootReducer";

let prevPathname = "";

export const prevPathnameMiddleware: Middleware<unknown, RootState> = () => (
  next
) => (action) => {
  const { type, payload } = action;

  if (type === LOCATION_CHANGE) {
    const { location } = payload;
    const actionWithPrevPathnamePayload = {
      ...action,
      payload: { ...payload, location: { ...location, prevPathname } },
    };
    prevPathname = location.pathname;

    return next(actionWithPrevPathnamePayload);
  }

  return next(action);
};
